import { BehaviorSubject } from "rxjs";

const showModalTopClient = new BehaviorSubject(false);

export const modalService = {
  modalState: showModalTopClient.asObservable(),
  open: () => showModalTopClient.next(true),
  close: () => showModalTopClient.next(false),
};